import React, { useMemo } from "react";
import styled from "styled-components";
import Modal from "../../../../components/Modal";
import { Typography, Grid } from "@mui/material";
import * as Yup from "yup";
import { FormikProvider, useFormik } from "formik";
import FormSelectInput from "../../../../components/FormSelectInput";

const MainContainer = styled.div`
  padding-bottom: 40px;
  min-height: 100px;
  width: 100%;
  .numberField {
    margin-top: 20px;
  }
  .responseContainer {
    margin-top: 12px;
    .listItem {
      display: flex;
      flex-direction: row;
      margin-left: 10px;
    }
  }
`;

const CopyFromModal = ({
  selectedVariant,
  onCancel,
  onCopy,
  isLoading,
  models,
}) => {
  const validationSchema = Yup.object().shape({
    modelName: Yup.string().trim().required("Required"),
    variant: Yup.string().required("Required"),
  });

  const modelData = useMemo(() => {
    return models.map((val) => {
      return {
        value: val.modelName,
        label: val.modelName,
        variants: val?.variants?.map((item) => ({
          value: item?.variantName,
          label: item?.variantName,
          ...item,
        })),
      };
    });
  }, [models]);

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      modelName: "",
      variant: "",
    },
    validationSchema: validationSchema,
    validateOnBlur: false,
    onSubmit: (values) => {
      const featuresData = variantOptions.find(
        (val) => val.value === values.variant
      )?.features;
      onCopy(featuresData);
    },
  });

  const variantOptions = useMemo(() => {
    const variants = modelData.find(
      (i) => i.value === formik.values?.modelName
    )?.variants;

    const filteredVariants = variants?.filter(
      (val) => val?.variantId !== selectedVariant?.id
    );
    return filteredVariants;
  }, [formik.values?.modelName, modelData, selectedVariant]);

  return (
    <Modal
      onSubmit={() => formik.handleSubmit()}
      confirmTitle={"Copy"}
      cancelTitle={"Cancel"}
      onCancel={onCancel}
      isLoading={isLoading}
      isDisabled={!formik.dirty || !formik.isValid}
    >
      <MainContainer>
        <Typography
          variant="h6"
          textAlign={"center"}
          fontWeight={700}
          width={"100%"}
          marginBottom={2}
        >
          {"Copy From Machine"}
        </Typography>
        <FormikProvider value={formik}>
          <Grid container spacing={2} marginBottom={2}>
            <Grid item xs={6}>
              <FormSelectInput
                name={"modelName"}
                options={modelData}
                label="Machine Model"
              />
            </Grid>
            <Grid item xs={6}>
              <FormSelectInput
                name={"variant"}
                options={variantOptions}
                label={"Variant"}
              />
            </Grid>
          </Grid>
        </FormikProvider>
      </MainContainer>
    </Modal>
  );
};

export default CopyFromModal;
